export function checkPasswordStrength(password) {
  // Initialize variables
  let strength = 0;
  let tips = '';

  if (!password) {
    return undefined;
  }

  // Check password length
  if (password.length < 8) {
    tips += 'Make the password longer. ';
  } else {
    strength += 1;
  }

  // Check for mixed case
  if (password.match(/[a-z]/) && password.match(/[A-Z]/)) {
    strength += 1;
  } else {
    tips += 'Use both lowercase and uppercase letters. ';
  }

  // Check for numbers
  if (password.match(/\d/)) {
    strength += 1;
  } else {
    tips += 'Include at least one number. ';
  }

  // Check for special characters
  if (password.match(/[^a-zA-Z\d]/)) {
    strength += 1;
  } else {
    tips += 'Include at least one special character. ';
  }

  // Return results
  if (strength < 2) {
    return `Easy to guess. ${tips}`;
  }
  if (strength === 2) {
    return `Medium difficulty. ${tips}`;
  }
  if (strength === 3) {
    return `Difficult. ${tips}`;
  }
  return undefined; // 'Extremely difficult. ' + tips;
}

export function checkConfirmPassword(confirmPassword, password) {
  if (!confirmPassword && !password) {
    return undefined;
  }
  if ((!password && confirmPassword) || (password && !confirmPassword)) {
    return 'Please specify password';
  }
  return confirmPassword !== password ? 'Password does not match' : undefined;
}
